<template>
  <div id="app">
    <Navbar :companyInfo="companyInfo" />
    <router-view />
    <BotBar />
  </div>
</template>

<script>
const settings = require("./settings.js");
import Navbar from "./components/navbar/Nvabar";
import BotBar from "./components/botbar/BotBar";
import { getCompany } from "@/api/api";
export default {
  components: {
    Navbar,
    BotBar
  },
  data() {
    return {
      companyInfo: {}
    };
  },
  created() {
    this.$nextTick(() => {
      document.head.querySelectorAll("link").forEach(link => {
        if (link.rel === "icon") {
          link.parentNode.removeChild(link);
        }
      });
      const link = document.createElement("link");
      link.rel = "icon";
      link.href =
        "https://cdn.zhihuangongshe.com/appHtml/official-website/app/" +
        settings.companyType +
        "/favicon.png?" +
        new Date().getTime();
      document.head.append(link);
    });
    this.getCompanyInfo();
  },
  methods: {
    getCompanyInfo() {
      getCompany().then(resp => {
        if (resp) {
          this.companyInfo = resp.data.data;
          document.title = this.companyInfo.name;
        }
      });
    }
  }
};
</script>
<style lang="less">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  overflow: hidden;
  min-width: 1200px;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
